<template>
  <section>
      <b-field label="Query ID">
        <b-input v-model="queryID"></b-input>
      </b-field>
      <b-field label="Query Parameters">
        <b-input v-model="queryParams"></b-input>
      </b-field>
      <b-field label="Time Period">
        <b-input v-model="from"></b-input>
        <b-input v-model="to"></b-input>
        <b-icon @click.native="refreshDate" icon="sync-alt" class="is-clickable"> </b-icon>
      </b-field>
      <b-field label="Query">
        coming soon..
      </b-field>
      <b-collapse :open="false" aria-id="contentIdForA11y1">
            <template #trigger="props">
                <b aria-controls="contentIdForA11y1">
                   Query Builder
                   <b-icon pack="fas" :icon="!props.open ? 'angle-down' : 'angle-up'"></b-icon>
                </b>
            </template>
            <div class="notification">
              <div class="card-content">
                <div class="content">
                    <p>{{selectedQuery.toString()}}</p>
                    <p v-if="selectedQuery.length > 0" @click="clearQuery" ><b-icon pack="fas" icon="times-circle"></b-icon></p>
                    <p> 
                      <b-button @click="selectQuery" type="is-info is-light">Select</b-button>                      
                    </p>
                    <QuerySelect v-for="(item, index) in schema" :key="index" :data="item" :queryArray.sync="selectedQuery"/>                     
                </div>
              </div>
            </div>
      </b-collapse>
      <b-button  @click="getQuery" type="is-info" :loading="isLoading" v-if="queryID">Query</b-button>
      <b-table :data="data" :columns="columns" :scrollable="true" :paginated="true"></b-table>
  </section>
</template>

<script>
import axios from "axios";
import QuerySelect from "@/components/QuerySelect.vue";
import { getToken } from "../session";

export default {
  name: "Query",
  components: { QuerySelect },
  props: ["unitID", "token"],
  data() {
    return {
      queryID: this.unitID,
      queryParams: "Id, DataReadDateTime",
      //allQueryParams: "SampleTime.dtDateTime,SampleTime.Hour,SampleTime.MonthRefreshed,SampleTime.WeekdayRefreshed,SampleTime.HundredSeconds,SampleTime.Minutes,SampleTime.Date,SampleTime.DateRefreshed,SampleTime.HourRefreshed,SampleTime.Weekday,SampleTime.Month,SampleTime.Year,SampleTime.YearRefreshed,SampleTime.Seconds,SampleTime.strDateTime,ChargerStatus,VoltageMeterings.0.VoltageOffsetApplied,VoltageMeterings.0.Frequency,VoltageMeterings.0.VoltageReading,VoltageMeterings.0.VoltageRawValue,VoltageMeterings.1.VoltageOffsetApplied,VoltageMeterings.1.Frequency,VoltageMeterings.1.VoltageReading,VoltageMeterings.1.VoltageRawValue,BatMetering.SenseCurrent,BatMetering.ChargeReading,BatMetering.SenseCurrentReading,BatMetering.Charge,BatMetering.temperature,BatMetering.temperatureReading,BatMetering.BatteryVoltageReading,BatMetering.BatteryVoltage,OutputAreaMeterings.0.CTReading,OutputAreaMeterings.0.ChannelPower,OutputAreaMeterings.0.OverPower,OutputAreaMeterings.0.Voltage.VoltageOffsetApplied,OutputAreaMeterings.0.Voltage.Frequency,OutputAreaMeterings.0.Voltage.VoltageReading,OutputAreaMeterings.0.Voltage.VoltageRawValue,OutputAreaMeterings.0.CTRawValue,OutputAreaMeterings.0.ChannelPGAGain,OutputAreaMeterings.0.status,OutputAreaMeterings.1.CTReading,OutputAreaMeterings.1.ChannelPower,OutputAreaMeterings.1.OverPower,OutputAreaMeterings.1.Voltage.VoltageOffsetApplied,OutputAreaMeterings.1.Voltage.Frequency,OutputAreaMeterings.1.Voltage.VoltageReading,OutputAreaMeterings.1.Voltage.VoltageRawValue,OutputAreaMeterings.1.CTRawValue,OutputAreaMeterings.1.ChannelPGAGain,OutputAreaMeterings.1.status,OutputAreaMeterings.2.CTReading,OutputAreaMeterings.2.ChannelPower,OutputAreaMeterings.2.OverPower,OutputAreaMeterings.2.Voltage.VoltageOffsetApplied,OutputAreaMeterings.2.Voltage.Frequency,OutputAreaMeterings.2.Voltage.VoltageReading,OutputAreaMeterings.2.Voltage.VoltageRawValue,OutputAreaMeterings.2.CTRawValue,OutputAreaMeterings.2.ChannelPGAGain,OutputAreaMeterings.2.status,OutputAreaMeterings.3.CTReading,OutputAreaMeterings.3.ChannelPower,OutputAreaMeterings.3.OverPower,OutputAreaMeterings.3.Voltage.VoltageOffsetApplied,OutputAreaMeterings.3.Voltage.Frequency,OutputAreaMeterings.3.Voltage.VoltageReading,OutputAreaMeterings.3.Voltage.VoltageRawValue,OutputAreaMeterings.3.CTRawValue,OutputAreaMeterings.3.ChannelPGAGain,OutputAreaMeterings.3.status,OutputAreaMeterings.4.CTReading,OutputAreaMeterings.4.ChannelPower,OutputAreaMeterings.4.OverPower,OutputAreaMeterings.4.Voltage.VoltageOffsetApplied,OutputAreaMeterings.4.Voltage.Frequency,OutputAreaMeterings.4.Voltage.VoltageReading,OutputAreaMeterings.4.Voltage.VoltageRawValue,OutputAreaMeterings.4.CTRawValue,OutputAreaMeterings.4.ChannelPGAGain,OutputAreaMeterings.4.status,OutputAreaMeterings.5.CTReading,OutputAreaMeterings.5.ChannelPower,OutputAreaMeterings.5.OverPower,OutputAreaMeterings.5.Voltage.VoltageOffsetApplied,OutputAreaMeterings.5.Voltage.Frequency,OutputAreaMeterings.5.Voltage.VoltageReading,OutputAreaMeterings.5.Voltage.VoltageRawValue,OutputAreaMeterings.5.CTRawValue,OutputAreaMeterings.5.ChannelPGAGain,OutputAreaMeterings.5.status,OutputAreaMeterings.6.CTReading,OutputAreaMeterings.6.ChannelPower,OutputAreaMeterings.6.OverPower,OutputAreaMeterings.6.Voltage.VoltageOffsetApplied,OutputAreaMeterings.6.Voltage.Frequency,OutputAreaMeterings.6.Voltage.VoltageReading,OutputAreaMeterings.6.Voltage.VoltageRawValue,OutputAreaMeterings.6.CTRawValue,OutputAreaMeterings.6.ChannelPGAGain,OutputAreaMeterings.6.status,DataReadDateTime,Id",
      schema: [
        "Id",
        "DataReadDateTime",
        {
          SampleTime: [
            "dtDateTime",
            "Hour",
            "MonthRefreshed",
            "WeekdayRefreshed",
            "HundredSeconds",
            "Minutes",
            "Date",
            "DateRefreshed",
            "HourRefreshed",
            "Weekday",
            "Month",
            "Year",
            "YearRefreshed",
            "Seconds",
            "strDateTime",
          ],
        },
        "ChargerStatus",
        {
          VoltageMeterings: [
            "0.VoltageOffsetApplied",
            "0.Frequency",
            "0.VoltageReading",
            "0.VoltageRawValue",
            "1.VoltageOffsetApplied",
            "1.Frequency",
            "1.VoltageReading",
            "1.VoltageRawValue",
          ],
        },
        {
          BatMetering: [
            "SenseCurrent",
            "ChargeReading",
            "SenseCurrentReading",
            "Charge",
            "temperature",
            "temperatureReading",
            "BatteryVoltageReading",
            "BatteryVoltage",
          ],
        },
        {
          OutputAreaMeterings: [
            "0.CTReading",
            "0.ChannelPower",
            "0.OverPower",
            "0.Voltage.VoltageOffsetApplied",
            "0.Voltage.Frequency",
            "0.Voltage.VoltageReading",
            "0.Voltage.VoltageRawValue",
            "0.CTRawValue",
            "0.ChannelPGAGain",
            "0.status",
            "1.CTReading",
            "1.ChannelPower",
            "1.OverPower",
            "1.Voltage.VoltageOffsetApplied",
            "1.Voltage.Frequency",
            "1.Voltage.VoltageReading",
            "1.Voltage.VoltageRawValue",
            "1.CTRawValue",
            "1.ChannelPGAGain",
            "1.status",
            "2.CTReading",
            "2.ChannelPower",
            "2.OverPower",
            "2.Voltage.VoltageOffsetApplied",
            "2.Voltage.Frequency",
            "2.Voltage.VoltageReading",
            "2.Voltage.VoltageRawValue",
            "2.CTRawValue",
            "2.ChannelPGAGain",
            "2.status",
          ],
        },
      ],
      isLoading: false,
      url: "",
      data: [],
      selectedQuery: [],
      from: new Date((new Date).getTime() - 10000).toISOString().slice(0, -5),
      to: new Date().toISOString().slice(0, -5)
    }
  },
  methods: {
    async getQuery() {
      const token = await getToken();
      axios
        .get(this.createUrl(120), {
          headers: {
            "X-Amz-Security-Token": token,
          },
        })
        .then((response) => (this.data = response.data.Items))
        .catch(function(error) {
          console.log(JSON.stringify(error));
        });
    },
    selectQuery() {
      this.queryParams = this.selectedQuery.toString();
    },
    clearQuery() {
      this.selectedQuery = [];
    },
    refreshDate() {
      this.to = new Date().toISOString().slice(0, -5);
    },
    createPeriod(timePeriod){
      let dateEnd = new Date();
      let dateStart = new Date(dateEnd.getTime() - timePeriod * 1000);
      let period = {};
      period.s = dateStart.toISOString().replace("Z", "");
      period.e = dateEnd.toISOString().replace("Z", "");
      let periodString =
        "&period=date" + encodeURIComponent(JSON.stringify(period));
      return periodString;
    },
    createUrl(){
      let baseURL = process.env.VUE_APP_API_BASE + this.unitID + '/data';
      // let dateEnd = new Date();
      // let dateStart = new Date(dateEnd.getTime() - timePeriod*1000);
      //return baseURL + '/' + dateStart.toISOString().replace('Z','') + '/' + dateEnd.toISOString().replace('Z','')
      return baseURL + '/' + this.from + '/' + this.to
    }
  },
  computed: {
    columns: function() {
      if (this.queryParams != "*") {
        return this.queryParams
          .replace(/\s/g, "")
          .split(",")
          .map((item) => {
            const container = {};
            container.field = item;
            container.label = item;
            return container;
          });
      } else {
        return this.allQueryParams
          .replace(/\s/g, "")
          .split(",")
          .map((item) => {
            const container = {};
            container.field = item;
            container.label = item;
            return container;
          });
      }
    },
    allQueryParams() {
      let arr = this.schema.map((str) => {
        if (typeof str === "object") {
          let key = Object.keys(str)[0];
          return str[key].map((obj) => {
            return key + "." + obj;
          });
        } else {
          return str;
        }
      });
      return [].concat(...arr).join();
    },
  },
  watch: {
    unitID: function() {
      this.queryID = this.unitID;
    },
    token() {
      this.url =
        "https://48927fuz4c.execute-api.eu-west-2.amazonaws.com/testV2/" +
        this.unitID +
        "?token=" +
        this.token +
        this.createPeriod(1000);
    },
  },
  created() {
    axios.interceptors.request.use(
      (config) => {
        this.isLoading = true;
        return config;
      },
      (error) => {
        this.isLoading = false;
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      (response) => {
        this.isLoading = false;
        return response;
      },
      (error) => {
        this.isLoading = false;
        return Promise.reject(error);
      }
    );
  },
};
</script>
